<template>
    <div>
        <el-card>
            <el-form :inline="true">
                <el-form-item label="存物时间">
                     <el-date-picker
                     :editable="false"
      v-model="dateRange"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
                </el-form-item>
        <el-form-item label="关键字">
 <el-input placeholder="请输入姓名、手机号"
 v-model="queryInfo.condition.keyWord" style="width:160px"></el-input>
         </el-form-item>
     <el-form-item label="状态" >
    <el-select v-model="queryInfo.condition.status" style="width:100px">
<el-option label="全部" value=""></el-option> 
<el-option label="正常" value="正常"></el-option>
<el-option label="作废" value="作废"></el-option> 
    </el-select>
     </el-form-item>
     <el-button class="searchBtn" @click="getListData">查询</el-button>
            </el-form>
            <div class="twoBox">
            <div class="leftBox" >
          <el-table :data="leftTable" height="90%">
<el-table-column label="单号" align="center" prop="orderNumber"></el-table-column>
            <el-table-column label="客户" align="center" prop="userName"></el-table-column>
 <el-table-column label="总存数" align="center" prop="num"></el-table-column>
 <el-table-column label="剩余" align="center" prop="surplusNum"></el-table-column>
     <el-table-column label="创建时间" align="center">
         <template slot-scope="scope">
          <span> {{scope.row.createDt | dataFormat}}</span>
                </template>
            </el-table-column>
            <el-table-column label="过期时间" align="center">
        <template slot-scope="scope">
        <span >{{scope.row.validityDt}}</span>
                </template>
            </el-table-column>
            <el-table-column label="状态" align="center" prop="status"></el-table-column>
          </el-table>
          <div style="height:10%">
             <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
          </div>
            </div>
            <div class="rightBox">
                <div class="content">
             <div class="cwxx">存物信息</div>
            <div class="rightTop">
                <div class="item">电话</div>
                <div class="item">客户</div>
                <div class="item">有效期</div>
                <div class="item">存酒时间</div>
                <div class="item">状态</div>
                <div class="item">备注</div>
            </div>
            <div class="rightFirstTable">
                <el-table style="height:100%">
                    <el-table-column label="名称" align="center"></el-table-column>
                    <el-table-column label="单位" align="center"></el-table-column>
                    <el-table-column label="数量" align="center"></el-table-column>
                    <el-table-column label="剩余" align="center"></el-table-column>
                    <el-table-column label="说明" align="center"></el-table-column>
                </el-table>
            </div>
            <div class="rightSecondTable">
                <div class="topText" >取物记录</div>
                <div class="secondTable">
                    <el-table :header-row-style="{'background-color': '#59a23','color': '#fff'}">
                    <el-table-column label="取物单号" align="center"></el-table-column>
                    <el-table-column label="物品名称" align="center"></el-table-column>
                    <el-table-column label="数量" align="center"></el-table-column>
                    <el-table-column label="时间" align="center"></el-table-column>
                    </el-table>
                </div>
            </div>
            </div>
                </div>
            </div>
            <div class="bottomBtn">
                <el-button @click="()=>{saveDialog=true}" class="myBtn">存物品</el-button>
                <el-button @click="()=>{getDialog=true}" class="myBtn">取物品</el-button>
                <el-button class="myBtn">单据作废</el-button>
                <!-- <el-button class="myBtn">关闭</el-button> -->
            </div>
        </el-card>
        <el-dialog
  title="新增存物"
  class="saveDialogBoxS"
  :visible.sync="saveDialog"
  width="60%">
  <div class="saveDialogBox">
    <div class="top">
        <div class="left">
           <el-form label-width="90px">
            <el-form-item label="手机号码">
 <el-input v-model="saveForm.phone" style="width:160px"></el-input>
            </el-form-item>
             <el-form-item label="姓名">
 <el-input v-model="saveForm.userName" style="width:160px"></el-input>
            </el-form-item>
             <el-form-item label="有效期">
               <el-date-picker
               style="width:160px"
      v-model="saveForm.validityDt"
      value-format="yyyy-MM-dd"
      type="date"
      :editable="false"
      placeholder="选择日期">
    </el-date-picker>
            </el-form-item>
                 <el-form-item label="备注">
<el-input v-model="saveForm.remark" style="width:160px"></el-input>
            </el-form-item>
            </el-form> 
        </div>
        <div class="right">
            <div style="width:100%">
         <div style="color:#080004;font-size:12px">历史存物</div>
        <el-table style="width:100%;height:158px;margin-top:5px" border>
          <el-table-column label="名称"></el-table-column>  
          <el-table-column label="单位"></el-table-column>  
          <el-table-column label="数量"></el-table-column>  
          <el-table-column label="剩余"></el-table-column>  
          <el-table-column label="说明"></el-table-column>  
        </el-table>
        </div>
     </div>
    </div>
    <div class="bottom">
        <div class="left">
            <el-form label-width="90px">
     <el-form-item label="品项名称">
 <el-input v-model="saveTable.productName" style="width:160px" placeholder="请输入名称"></el-input>  
     </el-form-item>
  <el-form-item label="单位">
      <el-input v-model="saveTable.unit" style="width:160px" placeholder="请输入单位"></el-input>  
    </el-form-item>
     <el-form-item label="数量">
     <el-input-number v-model.number="saveTable.num" :min="1" style="width:160px" placeholder="请输入数量"></el-input-number>  
   </el-form-item>
   <el-form-item label="位置">
     <el-input v-model="saveTable.location" style="width:160px" placeholder="请输入位置"></el-input>  
     </el-form-item>
    <el-form-item label="估价">
 <el-input v-model="saveTable.assessPrice" style="width:160px" placeholder="请输入估价"></el-input>  
   </el-form-item>
 <el-form-item label="说明">
   <el-input v-model="saveTable.remark" style="width:160px" placeholder="其他说明"></el-input>  
  </el-form-item>
     </el-form>
  <div style="display:flex;justify-content:right;width:100%;margin-top:16px;">
    <el-button @click="addOne">添加品项</el-button></div>
        </div>
        <div class="right">
        <div style="width:100%">
         <div style="color:#080004;font-size:12px">本次存物</div>
        <el-table height="208px" :data="saveTableNow"
         style="width:100%;height:158px;margin-top:5px;" border>
          <el-table-column prop="productName" label="品项名称"></el-table-column>  
          <el-table-column prop="unit" label="单位"></el-table-column>  
          <el-table-column prop="num" label="数量"></el-table-column>  
          <el-table-column prop="location" label="位置"></el-table-column>  
          <el-table-column prop="assessPrice" label="估价"></el-table-column>  
          <el-table-column prop="remark" label="说明"></el-table-column>  
        </el-table>
        <div><el-button>删除</el-button></div>
        </div>
        </div>
    </div>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button class="simpleBtn" @click="saveDialog = false">取 消</el-button>
    <el-button class="isBtn simpleBtn"  @click="saveProduct">确 定</el-button>
  </span>
</el-dialog>
  <el-dialog
  title="取物"
  class="saveDialogBoxS get"
  :visible.sync="getDialog"
  width="60%">
  <div class="getDialogBox">
    <div class="tops"><span>当前单物品列表</span> <span>当前顾客：xxx</span></div>
    <div class="twos">
        <div class="lefts">
        <el-table style="width:100%;height:200px" border>
    <el-table-column label="存物单号"></el-table-column> 
    <el-table-column label="客户姓名"></el-table-column> 
    <el-table-column label="品项名称"></el-table-column> 
    <el-table-column label="数量"></el-table-column> 
    <el-table-column label="剩余"></el-table-column> 
    <el-table-column label="位置"></el-table-column> 
    <el-table-column label="状态"></el-table-column> 
        </el-table>
        <div style="margin-top:10px">
            <span>此客户其他可取物品</span>
            <span style="padding:0 6px 0 30px">关键字:</span>
            <el-input style="width:120px;" placeholder="请输入品项名"></el-input>
        <el-button style="line-height:24px;height:24px;margin-left:12px">查询</el-button>
        </div>
     <el-table style="width:100%;height:200px;margin-top:6px" border>
    <el-table-column label="存物单号"></el-table-column> 
    <el-table-column label="客户姓名"></el-table-column> 
    <el-table-column label="品项名称"></el-table-column> 
    <el-table-column label="数量"></el-table-column> 
    <el-table-column label="剩余"></el-table-column> 
    <el-table-column label="位置"></el-table-column> 
    <el-table-column label="状态"></el-table-column> 
        </el-table>
        </div>
        <div class="rights"></div>
    </div>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button class="simpleBtn" @click="getDialog = false">取 消</el-button>
    <el-button class="isBtn simpleBtn"  @click="getDialog = false">确 定</el-button>
  </span>
</el-dialog>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                getDialog:false,
                saveForm:{
                    phone:'',
                    userName:'',
                    validityDt:'',
                    remark:''
                },
                saveTable:{
                    productName:'',
                    unit:"",
                    num:"",
                    location:"",
                    assessPrice:"",
                    remark:""
                },
                saveTableNow:[],
                saveDialog:false,
                leftTable:[],
                dateRange:'',
                total:0,
                queryInfo:{
                    currPage:1,
                    pageSize:10,
                    condition:{
                        keyWord:'',
                        status:'',
                        merchantCode:localStorage.getItem('merchantCode'),
                        merchantName:localStorage.getItem('merchantName')

                    }
                }
            }
        },
    created(){
    this.getListData()
        },
        methods:{
            // 存物
    async saveProduct(){
        let data={
    merchantCode:localStorage.getItem('merchantCode'),
    merchantName:localStorage.getItem('merchantName'),
    merchantStorageOrderItemList:this.saveTableNow,
    ...this.saveForm
        }
let res=await this.$http.post('merchantStorageOrder/saveMerchantStorageOrder/',data)
 if(res.data.code==200){
          this.$notify({
          title: '提示',
          message: '保存成功',
          type: 'success'
        });
        this.getListData()
        this.saveDialog=false
 }else{
    this.$message.error(res.data.message)
 }    
       },
        addOne(){
    if(this.saveTable.productName==''){this.$message.error('请输入品项名'); return;}
      let arr=JSON.parse(JSON.stringify(this.saveTable))
       this.saveTableNow.push(arr)
     this.saveTable.productName=''
     this.saveTable.unit=''
     this.saveTable.assessPrice=''
     this.saveTable.location=''
     this.saveTable.num=1
     this.saveTable.remark=''
         },
        async getListData(){
        if(this.dateRange!='' && this.dateRange.length!=0 && this.dateRange!=null){
            this.queryInfo.condition.startDate=this.dateRange[0]
            this.queryInfo.condition.endDate=this.dateRange[1]
        }else{
            this.queryInfo.condition.startDate=null
            this.queryInfo.condition.endDate=null
        }
       let res=await this.$http.post('merchantStorageOrder/list',this.queryInfo)
      this.leftTable=res.data.data.data
      this.total=res.data.data.count
        },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },
        }
    }
</script>

<style lang="scss" scoped>
.getDialogBox{
    width: 100%;
    .tops{
        width: 35%;
        display: flex;
        justify-content: space-between;
    }
    .twos{
        margin-top: 8px;
        display: flex;
        .lefts{
            width: 70%;
        }
    }
}
.twoBox{
    width: 100%;
    display: flex;
    .leftBox{
        width: 65%;
    }
    .rightBox{
        display: flex;
        flex:1;
        height: calc(100vh - 210px);
        border-left: 1px solid #848484;
        color: #000000;
        font-size: 14px;
        .content{
            box-sizing: border-box;
            width: 100%;
            .rightSecondTable{
                 height: 32%;
                 margin-top: 8px;
                .topText{
                margin-left: 8px;
                margin-bottom: 6px;
                }
                .topText::after{
                     content: ":";
            position: relative;
            top: -0.5px;
            margin: 0px 0px 0px 2px;
                }
            }
            .rightFirstTable{
                height: 32%;
                margin-top: 16px;
                border: 1px solid #9E9E9E;
            }
            .cwxx{
                margin-left: 8px;
                margin-bottom: 6px;
            }
            .cwxx::after{
           content: ":";
            position: relative;
            top: -0.5px;
            margin: 0px 0px 0px 2px;
            }
            .rightTop{
                padding: 6px 8px;
                display: flex;
                flex-wrap: wrap;
                border: 1px solid #FF0202;
                .item{
                    width: 50%;
                    margin-bottom: 7px;
                }
                .item::after{
                content: ":";
                position: relative;
                top: -0.5px;
                margin: 0px 0px 0px 2px;
                }
            }
        }
    }
}
/deep/ .el-form-item__label::after{
  content: ":";
  position: relative;
  top: -0.5px;
  margin: 0px 0px 0px 2px;
}
/deep/ .el-form-item__content>.el-date-editor{
    width: 260px;
}
/deep/ .el-form-item.el-form-item--small{
    margin-right: 16px;
}
/deep/ .searchBtn{
    background-color: #FF9900;
    color: #fff;
}
/deep/ .el-card__body{
    height: calc(100vh - 113px);
}
/deep/ .el-table{
    margin-top: 0;
}
/deep/ .bottomBtn{
    border-top: 1px solid #848484;
    padding: 12px 10px;
    display: flex;
    justify-content: right;
    .myBtn{
    background-color: #FF9900;
    color: #fff;
    height: 40px;
    border-color: #FF9900;
    }
}
/deep/ .saveDialogBoxS{
    // .el-dialog__header{
    //     border-bottom: 1px solid #aaa;
    // }
    .top{
        display: flex;
        height: 180px;
        border-bottom: 1px dashed #aaa;
        .left{
            width: 35%;
        }
        .right{
            display: flex;
            flex: 1;
        }
    }
    .bottom{
        display: flex;
        margin-top: 16px;
        .left{
            width: 35%;
        }
        .right{
            display: flex;
            flex:1;
        }
    }
    .el-dialog__body{
        padding-top: 8px;
    }
    .el-form-item__label{
        font-size: 12px;
        line-height: 24px;
    }
    .el-form-item{
        margin-bottom: 10px;
    }
    .el-input__inner{
        height: 26px !important;
        line-height: 26px !important;
    }
    .el-form-item__content{
        line-height: 26px;
    }
}
/deep/ .simpleBtn:hover{
    border:1px solid #DCDFE6;
    color: #606266;
    background: #fff;
}
/deep/ .simpleBtn{
    border:1px solid #DCDFE6;
    color: #606266;
}
/deep/ .isBtn{
    border-color: #f59a23;
    background: #f59a23;
    color: #fff;
}
/deep/ .isBtn:hover{
    color: #fff;
     background: #f59a23;
     border-color: #f59a23;
}
</style>